<div class="file-upload" *ngIf="viewModel">
    <div class="image-upload-wrap"
        [style.backgroundColor]="viewModel.imageUploadWrapHovered ? viewModel.hoverColor : '#FFF'"
        (mouseover)="viewModel.imageUploadWrapHovered = true" (mouseout)="viewModel.imageUploadWrapHovered = false"
        [style.borderColor]="viewModel.primaryColor" [class.has-uploaded-data]="viewModel.hasUploadedData">
        <input #inputFile class="file-upload-input" (change)="viewModel.fileSelected($event)" type='file'
            accept=".csv" />
        <div class="drag-text">
            <h3>{{'CMD_AddFile_DisplayName' | NTSTranslate}}</h3>
            <svg-icon fontSize="40px" key="upload"></svg-icon>
        </div>
    </div>
    <p [class.hidden]="!(viewModel.hasError$ | async)" class="error-tip">{{viewModel.errorText}}</p>
    <div class="file-upload-content" [class.has-uploaded-data]="viewModel.hasUploadedData">
        <div [class.hidden]="viewModel.showProgressBar$ | async" class="file-upload-image"
            [innerHTML]="viewModel.txtFileDescription">
        </div>
        <div [class.hidden]="viewModel.showProgressBar$ | async" class="image-title-wrap">
            <button type="button" (click)="reset()" class="remove-image">{{'CMD_RemoveFile_DisplayName' |
                NTSTranslate}}</button>
        </div>
        <nts-loader [isVisible]="viewModel.showProgressBar$ | async" [animation]="true"></nts-loader>
    </div>
</div>
